module.exports = __webpack_public_path__ + "static/media/book2.63e7d784.jpg";